<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 700px; max-width: 90vw;">
      <q-card-section>
        <div class="text-h6">
          <q-icon name="dashboard_customize" color="purple" class="q-mr-sm" />
          Create Compound from Template
        </div>
      </q-card-section>

      <q-card-section>
        <div class="q-mb-md">
          <q-select
            :model-value="selectedTemplate"
            :options="templates"
            label="Select Template"
            outlined
            option-label="name"
            option-value="id"
            emit-value
            :loading="loadingTemplates"
            @update:model-value="$emit('update:selected-template', $event)"
          >
            <template #option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section avatar>
                  <q-icon name="dashboard_customize" color="purple" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ scope.opt.name }}</q-item-label>
                  <q-item-label caption>{{ scope.opt.description }}</q-item-label>
                  <q-item-label caption class="text-blue">
                    Components: {{ scope.opt.component_count }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>

        <div v-if="selectedTemplate" class="q-mb-md">
          <q-input
            :model-value="formData.name"
            label="Equipment Name"
            outlined
            :rules="[val => !!val || 'Name is required']"
            hint="E.g., CHWV-101"
            @update:model-value="$emit('update:name', $event)"
          />
        </div>

        <div v-if="selectedTemplate" class="q-mb-md">
          <q-input
            :model-value="formData.description"
            label="Description (Optional)"
            outlined
            type="textarea"
            rows="2"
            @update:model-value="$emit('update:description', $event)"
          />
        </div>

        <!-- Template Components Preview -->
        <q-card v-if="selectedTemplate && templateData" flat bordered>
          <q-card-section>
            <div class="text-subtitle2 q-mb-sm">Template Components:</div>
            <q-list dense separator>
              <q-item v-for="comp in templateData.components" :key="comp.type">
                <q-item-section avatar>
                  <q-icon name="precision_manufacturing" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ comp.brick_class }}</q-item-label>
                  <q-item-label caption>{{ comp.relationship }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-card-section>
        </q-card>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn
          color="purple"
          label="Create Compound"
          icon="dashboard_customize"
          :loading="saving"
          :disable="!selectedTemplate || !formData.name"
          @click="$emit('submit')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: { type: Boolean, required: true },
    templates: { type: Array, required: true },
    selectedTemplate: { type: Number, default: null },
    templateData: { type: Object, default: null },
    formData: { type: Object, required: true },
    loadingTemplates: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:selected-template',
    'update:name',
    'update:description',
    'submit',
  ]);
</script>
